export enum ExecutiveRefundRequestTabsEnum {
    Protocol = 0,
    SelecaoBeneficiario = 1,
    DadosParaCreditoEmConta = 2,
    DadosProcedimento = 3,
    RevisaoFinalizacao = 4,
}